module.exports = __webpack_public_path__ + "2877aadaed4cfa7bd234cbe90965cf05.MP3";